import type {NavigationGuardNext, RouteLocationNormalized} from 'vue-router';

/**
 * Normalizes period query params:
 * - If orderedAt !== 'period' remove periodFrom/periodUntil.
 * - If orderedAt === 'period' and until < from, copy from into periodUntil.
 */
export const ordersOverviewGuard = (to: RouteLocationNormalized) => {
  const {orderedAt, periodFrom, periodUntil} = to.query;

  const baseQuery = {...to.query};
  let modifiedQuery = baseQuery;
  let changed = false;

  if (orderedAt === 'period') {
    const hasBoth = Boolean(periodFrom) && Boolean(periodUntil);
    const invalid = hasBoth && new Date(String(periodUntil)).getTime() < new Date(String(periodFrom)).getTime();
    if (invalid) {
      modifiedQuery = {...baseQuery, periodUntil: String(periodFrom)};
      changed = true;
    }
  } else {
    if (periodFrom || periodUntil) {
      modifiedQuery = {...baseQuery};
      if (periodFrom) delete modifiedQuery.periodFrom;
      if (periodUntil) delete modifiedQuery.periodUntil;
      changed = true;
    }
  }

  if (changed) {
    const sameSize = Object.keys(baseQuery).length === Object.keys(modifiedQuery).length;
    const sameValues = sameSize && Object.keys(baseQuery).every((key) => baseQuery[key] === modifiedQuery[key]);
    if (!sameValues) {
      return {path: to.path, query: modifiedQuery};
    }
  }

  return true;
};
